import { jsx as _jsx } from "react/jsx-runtime";
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import { defineStyles } from '../theme';
import { useSTRows } from './SmartTableContext';
const styles = defineStyles({
    root: {
        fontWeight: 600,
        fontSize: 13,
        display: 'inline-block',
        minWidth: 150,
        textAlign: 'end',
    },
});
export const SelectionCountDisplay = () => {
    const { selectionCount, rowsCount } = useSTRows();
    return (_jsx(Typography, { component: "span", sx: styles.root, children: selectionCount > 0 ? (_jsx(FormattedMessage, { id: "table.records.selectedOfTotal", defaultMessage: "{selected, number} of {total, number} {total, plural, one {record} other {records}}", values: { selected: selectionCount, total: rowsCount } })) : (_jsx(FormattedMessage, { id: "table.records.totalOnly", defaultMessage: "{count, plural, one {# record} other {# records}}", values: { count: rowsCount } })) }));
};
//# sourceMappingURL=SelectionCountDisplay.js.map